// @flow
import React, { type Element } from 'react';
import { Input } from 'angieslist-react-components';
import './sortingOptions.scss';

type Props = {
  sortType: string,
  sortDirection: string,
  onSelect: (any) => any,
};

const options = [
  { label: 'Most Recent', value: 'recency;desc' },
  { label: '5-1 Ratings', value: 'starRating;desc' },
  { label: '1-5 Ratings', value: 'starRating;asc' },
  { label: 'Cost (high to low)', value: 'cost;desc' },
  { label: 'Cost (low to high)', value: 'cost;asc' },
];

const MobileSortingOptionsComponent = ({
  sortType,
  sortDirection,
  onSelect,
}: Props): Element<"div"> => (
  <div style={{ marginTop: 20 }}>
    <Input
      id="mobile-sorting-options--select"
      type="select"
      label="Sort by"
      onChange={(e) => {
        const { value } = e.target;
        const splitValue = value.split(';');
        onSelect({ sortType: splitValue[0], sortDirection: splitValue[1] });
      }}
    >
      {
        options.map((option, index) => (
          <option
            key={option.label}
            value={option.value}
            selected={`${sortType};${sortDirection}` === option.value}
          >
            {option.label}
          </option>
        ))
        }
    </Input>
  </div>
);

export default MobileSortingOptionsComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/MobileSortingOptions.js